module.exports = __webpack_public_path__ + "static/media/businessman.d93090e6.png";